import React, { useState, useEffect, useCallback } from 'react';

const AnimatedModal = ({ title, onClose, children, footer, size = '' }) => {
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setAnimateIn(true));
    document.body.classList.add('modal-open');
    return () => document.body.classList.remove('modal-open');
  }, []);

  const handleClose = useCallback(() => {
    setAnimateIn(false);
    setTimeout(onClose, 200);
  }, [onClose]);

  const dialogClass = ['modal-dialog modal-dialog-centered', size].filter(Boolean).join(' ');

  return (
    <>
      <div
        className={`modal fade d-block ${animateIn ? 'show' : ''}`}
        tabIndex="-1"
        role="dialog"
        style={{ transition: 'opacity 0.2s ease' }}
      >
        <div className={dialogClass} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="close" onClick={handleClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {children}
            </div>
            {footer && (
              <div className="modal-footer">
                {footer(handleClose)}
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={`modal-backdrop fade ${animateIn ? 'show' : ''}`}
        style={{ backdropFilter: 'blur(4px)', transition: 'opacity 0.2s ease' }}
        onClick={handleClose}
      />
    </>
  );
};

export default AnimatedModal;
